"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./ModalHeader.css");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chevronIconBlack = _interopRequireDefault(require("../../../../images/shared/icons/chevron-icon-black.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = function ModalHeader(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      _ref$closeModal = _ref.closeModal,
      closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-2020-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: closeModal
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _chevronIconBlack.default,
    alt: "close"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "header-context"
  }, primary && /*#__PURE__*/_react.default.createElement("h1", null, primary), secondary && /*#__PURE__*/_react.default.createElement("h2", null, secondary)));
};

var string = _propTypes.default.string,
    func = _propTypes.default.func;
ModalHeader.propTypes = {
  primary: string,
  secondary: string,
  closeModal: func
};
var _default = ModalHeader;
exports.default = _default;